import React from "react";
//#region redux
import { AppState } from "store";
import { useDispatch, useSelector } from "react-redux";
import { addIntroduction } from "store/actions/authActions";
//#endregion
//#region types
import { PersonCompanyRelationType } from "models/enums/auth";
import { CampaignConstants } from "utils/constants";
//#endregion
//#region components
import useTipDialog from "./useTipDialog";
import useUserService from "serviceHooks/useUserService";
import { CompanyService } from "services";
//#endregion

function useSummerCampaignModal(hasCompany: boolean) {
  const dispatch = useDispatch();
  const { openDialog } = useTipDialog();
  const { markIntroductionAsShown } = useUserService();
  const shownIntroductions = useSelector((state: AppState) => state.auth.profileToggles.shownIntroductions);
  const hasFired = React.useRef(false);

  React.useEffect(() => {
    if (!hasCompany || hasFired.current) return;
    if (!Array.isArray(shownIntroductions)) return;
    if (!CampaignConstants.isSummerCampaign2026Active(new Date())) return;
    if (shownIntroductions.includes(CampaignConstants.SummerCampaign2026.id)) return;
    if (!CompanyService.hasRelations([PersonCompanyRelationType.SalaryAdmin, PersonCompanyRelationType.InvoicesAdmin]))
      return;

    hasFired.current = true;
    openDialog();
    markIntroductionAsShown(CampaignConstants.SummerCampaign2026.id);
    dispatch(addIntroduction(CampaignConstants.SummerCampaign2026.id));
  }, [hasCompany, shownIntroductions]);
}

export default useSummerCampaignModal;
